module.exports = __webpack_public_path__ + "img/equipment.8a430a31.svg";